import { exportSidecar } from 'use-sidecar';
import FocusTrap from './Trap';
import { mediumSidecar } from './medium';
export default exportSidecar(mediumSidecar, FocusTrap);


//////////////////
// WEBPACK FOOTER
// ./~/react-focus-lock/dist/es2015/sidecar.js
// module id = 8999
// module chunks = 2